import { ApiErrorMessage, BaseApi } from "api";
import { endpoints } from "config";
import { FieldDetails } from "./apiModels";

class FieldDetailsApi extends BaseApi {
  /**
   * Parse errors from `getFieldDetails`
   */
  private static getFieldDetailsParseError: typeof this.parseGenericErrorMessageCode =
    (msg) => {
      switch (msg) {
        // API-specific error codes here, generic messages handled below
        default:
          return this.parseGenericErrorMessageCode(msg);
      }
    };

  /**
   * # Get details of a specific field in the panorama
   *
   * Also load in neighbouring fields
   */
  static getFieldDetails = async (params: {
    currentFieldID: string;
    panoramaGuid: string;
    listSphereFieldIDs: string;
  }) => {
    try {
      const result = await this.makeRequest<FieldDetails, ApiErrorMessage[]>({
        url: endpoints.fieldDetails.getKrpanoField,
        method: "GET",
        config: {
          params,
        },
      });
      if (this.isResponseSuccessful(result)) {
        return this.successResponse(result.data.details);
      } else {
        return this.errorResponse(
          this.getFieldDetailsParseError(result.data.errors[0].message_code)
        );
      }
    } catch (err: unknown) {
      return this.safelyCatchUnknownError<FieldDetails>(
        err,
        "getFieldDetails",
        this.getFieldDetailsParseError
      );
    }
  };
}

export default FieldDetailsApi;
